import { css } from '@emotion/css';

export const MainContainer = css`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  min-height: 100vh;
  background: var(--color-surface);

  @media (max-width: 900px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

export const LeftPanel = css`
  background: var(--gl-navy);
  color: var(--gl-white);
  padding: var(--space-3xl) var(--space-2xl);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: var(--space-2xl);

  /* The pitch is decorative; on a phone the form should own the viewport. */
  @media (max-width: 900px) {
    display: none;
  }
`;

export const Brand = css`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const BrandMark = css`
  width: 32px;
  height: 32px;
  border-radius: 9px;
  background: var(--gl-blue);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-bold);
`;

export const BrandName = css`
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-bold);
`;

export const Headline = css`
  margin: 0 0 var(--space-m);
  max-width: 420px;
  font-size: var(--font-size-2xl);
  font-weight: var(--font-weight-semibold);
  line-height: 1.3;
  text-wrap: pretty;
`;

export const Pitch = css`
  margin: 0;
  max-width: 420px;
  font-size: var(--font-size-sm);
  line-height: 1.6;
  color: var(--gl-blue-25);
  text-wrap: pretty;
`;

export const PanelFooter = css`
  font-size: var(--font-size-2xs);
  color: var(--gl-navy-50);
`;

export const RightPanel = css`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--space-2xl);
`;

export const ContentContainer = css`
  width: 100%;
  max-width: 360px;
  display: flex;
  flex-direction: column;
  gap: var(--space-ml);
`;
